module.exports = __webpack_public_path__ + "img/tablet-elbow-7_72x56.bff2f5e0.png";